import { render, staticRenderFns } from "./investigation-agreement.vue?vue&type=template&id=50c6d24d&"
import script from "./investigation-agreement.vue?vue&type=script&lang=js&"
export * from "./investigation-agreement.vue?vue&type=script&lang=js&"
import style0 from "./investigation-agreement.vue?vue&type=style&index=0&id=50c6d24d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports